<template>
    <v-container class="grey-lighten-3 full-height">

        <!-- Printable Area -->
        <v-row justify="center">
            <v-col cols="12" xl="10" lg="11" md="12">
                <v-sheet class="report-paper pa-5 mx-auto" elevation="3" id="printable-area">

                <!-- Header Section (Will repeat on each page) -->
                <div class="page-header">
                    <div class="header-section d-flex justify-space-between align-start lines">
                        <div class="company-info">
                            <h4 class="company-name text-uppercase font-weight-bold mb-1">
                                {{ purchaseRequisitionData?.branch?.company?.name }}
                            </h4>
                            <p class="company-text mb-1" style="width:65%">{{ purchaseRequisitionData?.branch?.company?.address }}</p>
                            <p class="company-text mb-1">
                                <v-icon size="small" class="mr-1">mdi-phone-outline</v-icon>
                                {{ purchaseRequisitionData?.branch?.company?.mobile }}
                            </p>
                            <p class="company-text mb-1">
                                <v-icon size="small" class="mr-1">mdi-email-outline</v-icon>
                                {{ purchaseRequisitionData?.branch?.company?.email }}
                            </p>
                            <p class="company-text" v-if="purchaseRequisitionData?.branch?.company?.website">
                                <v-icon size="small" class="mr-1">mdi-web</v-icon>
                                {{ purchaseRequisitionData?.branch?.company?.website }}
                            </p>
                        </div>

                        <div class="logo-container">
                            <v-img
                                :src="`${getFileServerUrl.replace(/\/$/, '')}/${purchaseRequisitionData?.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                                max-width="150" 
                                max-height="70" 
                                class="logo-img" 
                                contain
                            />
                        </div>
                    </div>

                    <!-- Title -->
                    <div class="text-center my-6">
                        <h2 class="report-title font-weight-bold">
                            PURCHASE REQUISITION INVOICE
                        </h2>
                    </div>
                </div>

                <!-- Main Content -->
                <div class="page-content">
                    <!-- Master Information -->
                    <div class="meta-info-box mb-4">
                        <div class="d-flex">
                            <div class="meta-item d-flex align-center" style="width: 50%; border-right: 1px solid #000; border-bottom:1px solid #000">
                                <span class="meta-label pl-2">Purchase Requisition Code:</span>
                                <span class="meta-value pl-2 font-weight-bold">{{ purchaseRequisitionData?.code }}</span>
                            </div>  
                            <div class="meta-item d-flex align-center" style="width: 50%; border-bottom:1px solid #000">
                                <span class="meta-label pl-2">Requisition Date:</span>
                                <span class="meta-value pl-2">{{ formatDateTime(purchaseRequisitionData?.requisition_date) }}</span>
                            </div>
                        </div>

                        <div class="d-flex" style=" border-bottom: 1px solid #000;">
                            <div class="meta-item d-flex align-center" style="border-right: 1px solid #000; width: 50%;">
                                <span class="meta-label pl-2">Warehouse: </span>
                                <span class="meta-value pl-2">{{ purchaseRequisitionData?.warehouse?.name }}</span>
                            </div>
                            <div class="meta-item d-flex align-center" style="width: 50%;">
                                <span class="meta-label pl-2">Purpose: </span>
                                <span class="meta-value pl-2">{{ purchaseRequisitionData?.purpose?.name }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Purchase Requisition Details Table -->
                    <div class="table-container mb-6">
                        <table class="dep-table">
                            <thead>
                                <tr>
                                    <th class="text-center" style="width: 40px;">SL</th>
                                    <th>Product Code</th>
                                    <th>Product Name</th>
                                    <th>Unit</th>
                                    <th>Total Quantity</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(detail, index) in purchaseRequisitionData?.requisition_details" :key="detail.id">
                                    <td class="text-center">{{ index + 1 }}</td>
                                    <td class="text-center">{{ detail.product?.code }}</td>
                                    <td class="text-center">{{ detail.product?.name }}</td>
                                    <td class="text-center">{{ detail.product?.unit.name }}</td>
                                    <td class="text-center">{{ detail?.qty  }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Prepared By Info -->
                    <div class="prepared-section mb-8">
                        <div class="font-weight-bold mb-1">Prepared By:</div>
                        <div>{{ purchaseRequisitionData?.created_by?.full_name || '-' }}</div>
                        <div class="text-caption">{{ formatDateTime(purchaseRequisitionData?.created_at) }}</div>
                    </div>
                </div>

                <div style="display: flex; flex-direction: column; justify-content: end; margin-top: 300px;">
                    <div style="display: flex; justify-content: space-between;">
                        <div>
                            <p style="border-top: 1px solid #555; width: 200px; margin: 0 auto; color: #333; text-align:center">
                            <span>Receiver's Signature</span>
                            </p>
                        </div>
                        <div>
                            <p style="border-top: 1px solid #555; width: 200px; margin: 0 auto; color: #333; text-align:center">
                            <span>Remex Ingredient Solution</span>
                            </p>
                        </div>
                    </div>
                </div>
                </v-sheet>
            </v-col>
        </v-row>

        <!-- Action Toolbar (Hidden on Print) -->
        <v-row class="d-print-none mb-4" justify="center">
            <v-col cols="12" md="8" lg="9" class="d-flex justify-center gap-2">
                <v-btn color="success" prepend-icon="mdi-download" @click="downloadPDF">
                    Download PDF
                </v-btn>

                <v-btn color="primary" prepend-icon="mdi-printer" @click="printPage">
                    Print
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
    name: "Sales",

    data: () => ({
        mainId: null,
        purchaseRequisitionData: null,
    }),
    
    watch: {},

    created() {
        const id = this.$route.query.id;
        this.mainId = id;
        this.$store.dispatch("getPurRequisitionById", id).then((response) => {
            console.log(response)
            this.purchaseRequisitionData = response;
        });
    },

    computed: {
        getFileServerUrl() {
            return this.$store.getters.getFileServerUrl;
        },
    },  

    methods: {
        formatDate(date) {
            if (!date) return "-";
            const d = new Date(date);
            return `${d.getDate().toString().padStart(2, "0")}/${(d.getMonth() + 1)
                .toString()
                .padStart(2, "0")}/${d.getFullYear()}`;
        },
        formatDateTime(dateTime) {
            if (!dateTime) return "-";
            const d = new Date(dateTime);
            return `${this.formatDate(dateTime)} ${d.toLocaleTimeString()}`;
        },
        formatNumber(num) {
            return num ? Number(num).toFixed(2) : "0.00";
        },
        async downloadPDF() {
            const element = document.getElementById("printable-area");
            const opt = {
                margin: [0.5, 0.5],
                filename: `purchase-requisition-${this.purchaseRequisitionData?.code}.pdf`,
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 2, useCORS: true },
                jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
            };
            await html2pdf().set(opt).from(element).save();
        },
        printPage() {
            const printContent = document.getElementById("printable-area").innerHTML;
            const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}, left=0, top=0`);

            printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="UTF-8">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <title>Purchase Requisition Invoice</title>
                    <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
                    <style>
                    * {
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                    }
                    body {
                        font-family: 'Times New Roman', serif;
                        background: white;
                        margin: 0;
                        padding: 20px;
                    }
                    .report-paper {
                        background-color: white;
                        color: black;
                        max-width: 100%;
                        width: 100%;
                        margin: auto;
                        padding: 20mm 15mm 15mm 15mm;
                        min-height: 277mm;
                        display: flex;
                        flex-direction: column;
                    }
                    .page-content {
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                    }
                    .header-section {
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-start;
                        border-bottom: 2px solid #eee;
                        padding-bottom: 10px;
                        margin-top: 16px;
                        margin-bottom: 16px;
                    }
                    .company-info {
                        flex: 1;
                    }
                    .company-name {
                        color: #333;
                        font-size: 20px;
                        font-weight: bold;
                        text-transform: uppercase;
                        margin: 0 0 4px 0;
                    }
                    .company-text {
                        font-size: 14px;
                        color: #555;
                        margin: 2px 0;
                        display: flex;
                        align-items: center;
                    }
                    .logo-container img {
                        max-height: 70px;
                        max-width: 150px;
                    }
                    .report-title {
                        color: #333;
                        font-size: 20px;
                        font-weight: bold;
                        text-align: center;
                        margin: 16px 0;
                    }
                    .meta-info-box {
                        border: 1px solid #000;
                        margin-bottom: 16px;
                    }
                    .meta-item {
                        height: 35px;
                        display: flex;
                        align-items: center;
                    }
                    .meta-label {
                        font-weight: 500;
                        color: #333;
                        padding-left: 8px;
                    }
                    .meta-value {
                        padding-left: 8px;
                        color: #555;
                    }
                    .d-flex {
                        display: flex;
                    }
                    .dep-table {
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 14px;
                        margin-bottom: 24px;
                    }
                    .dep-table th {
                        background-color: #f0f0f0;
                        border: 1px solid #000;
                        padding: 8px 5px;
                        color: #333;
                        text-align: center;
                    }
                    .dep-table td {
                        border: 1px solid #000;
                        padding: 8px 5px;
                        vertical-align: middle;
                        color: #555;
                        text-align: center;
                    }
                    .text-center {
                        text-align: center;
                    }
                    .text-right {
                        text-align: right;  
                    }
                    .prepared-section {
                        margin-bottom: 16px;
                        color: #555;
                    }
                    .font-weight-bold {
                        font-weight: bold;
                        color: #333;
                    }
                    .text-caption {
                        font-size: 12px;
                        color: #666;
                    }
                    .lines {
                        border-bottom: 2px solid #eee;
                        padding-bottom: 10px;
                    }
                    .signature-section {
                        margin-top: auto;
                        padding-top: 40mm;
                    }
                    .signature-row {
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-end;
                    }
                    .signature-item {
                        text-align: center;
                    }
                    .signature-line {
                        width: 200px;
                        border-top: 1px solid #555;
                        margin-bottom: 5px;
                    }
                    .signature-label {
                        color: #333;
                        font-size: 14px;
                    }
                    @page {
                        margin: 0;
                        size: A4 portrait;
                    }
                    @media print {
                        body {
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                            background: white !important;
                            padding: 0;
                            margin: 0;
                        }
                        .report-paper {
                            min-height: 277mm;
                            margin-top: 40px!important;
                        }
                    }
                    </style>
                </head>
                <body>
                    ${printContent}
                </body>
                </html>
            `);

            printWindow.document.close();
            printWindow.moveTo(0, 0);
            printWindow.focus();
            
            setTimeout(() => {
                printWindow.print();
                printWindow.onafterprint = () => {
                    printWindow.close();
                };
            }, 1000);
        }
    },
};
</script>

<style scoped>
.header-section {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.company-info {
    flex: 1;
}
.company-name {
    color: #333;
    font-size: 20px;
    letter-spacing: 0.5px;
}
.company-text {
    font-size: 14px;
    color: #555;
    margin: 2px 0;
    display: flex;
    align-items: center;
}
.logo-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.logo-img {
    max-height: 70px;
    max-width: 150px;
}
.report-title {
    color: #333;
    font-size: 20px;
}
.lines {
    border-bottom: 2px solid #eee;
    padding-bottom: 10px;
    margin-bottom: 16px;
}
.full-height {
    min-height: 100vh;
}
.grey-lighten-3 {
    background-color: #eeeeee !important;
}
.report-paper {
    background-color: white;
    color: black;
    font-family: 'Times New Roman', serif;
    max-width: 280mm;
    width: 100%;
    min-height: 297mm;
}
.meta-info-box {
    border: 1px solid #000;
}
.meta-item {
    height: 35px;
}
.meta-label {
    font-weight: 500;
    color: #333;
}
.meta-value {
    color: #555;
}
.dep-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}
.dep-table th {
    background-color: #f0f0f0;
    border: 1px solid #000;
    padding: 8px 5px;
    color: #333;
}
.dep-table td {
    border: 1px solid #000;
    padding: 8px 5px;
    vertical-align: middle;
    color: #555;
}
.text-center {
    text-align: center;
}
.text-right {
    text-align: right;  
}
.gap-2 {
    gap: 8px;
}

/* Print Styles */
@media print {
    .v-application,
    .v-main,
    body {
        background: white !important;
    }
    
    body > *:not(.v-application) {
        display: none !important;
    }
    
    .v-application > *:not(.v-application__wrap) {
        display: none !important;
    }
    
    .v-application__wrap > *:not(main) {
        display: none !important;
    }
    
    main * {
        visibility: hidden;
    }
    
    #printable-area,
    #printable-area * {
        visibility: visible;
    }
    
    #printable-area {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        padding: 15px;
        box-shadow: none !important;
        margin: 0 !important;
        display: table;
    }
    
    .page-header {
        display: table-header-group;
    }
    
    .page-content {
        display: table-row-group;
    }
    
    .report-paper {
        box-shadow: none !important;
        max-width: 100% !important;
        margin: 0 !important;
        padding: 15px !important;
    }
    
    .d-print-none {
        display: none !important;
    }
}
</style>